// extracted by mini-css-extract-plugin
export default {"systemDownloadHistory":"SystemDownloadHistory_systemDownloadHistory__PYXVA","details":"SystemDownloadHistory_details__eoLgT","headline":"SystemDownloadHistory_headline__3oKYc"};